export enum TypeCodeName {
  ACOR_ZERO = 'ACOR ZERO',
  ACOR_PURGE = 'ACOR PURGE',
  ACOR_RESET = 'ACOR RESET',
  VOID = 'VOID'
}
